<template >
  <div>
    <div
      class="row"
      style="text-align: center"
      v-if="currAdmin == undefined || currAdmin.id == undefined || currAdmin.id == ''"
    >
      <div class="col-12">Loading...{{currAdmin.id}}</div>
    </div>
    <b-row v-if="currAdmin != undefined && currAdmin.id != undefined && currAdmin.id != ''">
      <b-col cols="2" class="membersList" id="chatLists">
        <!-- <div class="row headerChatList">
          <div class="col-2" style="padding-right:0">
            <b-avatar :size="24" variant="success" :src="userPhotoURL"></b-avatar>
          </div>
          <div class="col-10 displayChatName">
            <div>{{currAdmin.userOptionalName}}</div>
          </div>
        </div>-->
        <!-- <div class="hrBackColor">
          <hr class="style-one" />
        </div>-->

        <ChatList
          :windowHeight="windowHeight"
          :windowWidth="windowWidth"
          :currAdmin="currAdmin"
          :rooms="rooms"
          :messages="messages"
          :watchAdminsList="watchAdminsList"
          :roomStats="roomStats"
          v-on:roomSelected="selectedRoomId = $event"
          v-on:expiredRoom="ExpiredRoomProcess"
        />
      </b-col>

      <b-col cols="7" class="noPaddingsLR" v-if="selectedRoomId != '' && roomExist">
        <MainChatWindow
          :key="rooms.findIndex(el => el.ssId == selectedRoomId)"
          :msgs="messages[selectedRoomId] || []"
          :room="rooms.find(el => el.ssId == selectedRoomId)"
          :windowHeight="windowHeight"
          :windowWidth="windowWidth"
          :maId="currAdmin.id"
          :admins="admins"
          v-on:switchChatTo="SwitchChatTo"
          v-on:sendMessage="SendMessage"
          v-on:blockNote="$emit('blockNote', $event)"
        />
      </b-col>

      <b-col class="notActiveChat" v-else>
        <div class="positionMiddle">
          <h2>Select customer to chat with</h2>
        </div>
      </b-col>

      <b-col cols="3" class="noPaddingsLR" v-if="selectedRoomId != '' && roomExist">
        <hr class="style-two" />

        <UserInfo
          :key="'ui-' + selectedRoomId"
          :user="allUsers[rooms.find(el => el.ssId == this.selectedRoomId).userId]"
          :clientId="rooms.find(el => el.ssId == this.selectedRoomId).userId"
          :room="rooms.find(el => el.ssId == this.selectedRoomId)"
          :myChat="rooms.find(el => el.ssId == this.selectedRoomId).adminId == currAdmin.id"
          :windowHeight="windowHeight"
          :windowWidth="windowWidth"
          v-on:addToUserInfo="addToAllUsers"
        />
      </b-col>
      <b-modal
        size="lg"
        ref="unfinishedChat"
        id="unfinishedChatModal"
        ok-title="Keep open"
        cancel-title="End conversation"
        @ok="ExtendExpireTime(expiredRoom.ssId)"
        @cancel="SwitchRoomTo(expiredRoom.ssId, expiredRoom.clientEndpoint == 'sms' ? 'smsFinished' : 'bot')"
        centered
        title="You have unfinished chats"
      >
        <div class="d-block text-center">
          <p>This conversation with {{expiredRoom && expiredRoom.userId ? expiredRoom.user_firstName + ' ' + expiredRoom.user_lastName + ' (' + expiredRoom.userId + ')' : 'UnIdentified Customer'}} will be switched back to bot soon.</p>
          <p>Click "Keep open" to leave this chat assigned to you</p>
        </div>
      </b-modal>

      <b-modal
        size="lg"
        ref="showWarning"
        cancel-title="End conversation"
        ok-only
        centered
        title="You have active chats"
        @hidden="nsmsphone = ''"
      >
        <div class="d-block text-center">
          <h6>Please note: All unfinished conversations with no recent activity will be over after 5pm with no warnings</h6>
        </div>
      </b-modal>

      <b-modal
        ref="newSMSRoom"
        id="newSMSRoom"
        title="Start New SMS Conversation"
        centered
        hide-footer
        @show="LoadTodaysAppointments()"
      >
        <b-tabs>
          <b-tab title="Enter Phone" active>
            <div class="row mt-4">
              <div class="col-12">
                Enter customer's phone number:
                <b-input-group prepend="+1" class="mt-2 mb-2 mr-sm-2 mb-sm-0">
                  <b-form-input
                    id="newSMSPhone"
                    v-model="nsmsphone"
                    type="tel"
                    placeholder="Enter phone number"
                    required
                  ></b-form-input>
                </b-input-group>
                <b-spinner variant="primary" label="Spinning" v-if="smsuserloading"></b-spinner>
                <div class="mt-3" v-if="searchInitiated && !smsuserloading">
                  <div v-if="foundUsers.length == 0" style="color: darkred">
                    <p style="margin:0;">No customers found by this phone number</p>
                    <p>Do you want to proceed anyway?</p>
                  </div>
                  <div v-else>
                    <div class="row" v-for="foundUser in foundUsers" :key="foundUser.id">
                      <div class="col-12" style="text-align:left;">
                        <b-form-checkbox
                          v-model="foundUserSelected"
                          :value="foundUser"
                          :unchecked-value="null"
                        >CustNo: {{foundUser.id}} - {{foundUser.firstName}} {{foundUser.lastName}}</b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-7"></div>
                  <!-- <div class="col-3"></div> -->
                  <div class="col-5">
                    <b-button
                      v-if="!searchInitiated"
                      style="width: 100%"
                      variant="outline-primary"
                      @click="searchSMSUser()"
                      :disabled="nsmsphone.length != 10"
                    >Ok</b-button>
                    <b-button
                      v-if="searchInitiated && nsmsphone.length == 10"
                      style="width: 100%"
                      variant="primary"
                      @click="CreateSMSRoom()"
                      :disabled="foundUsers.length > 0 && foundUserSelected == null"
                    >Create{{foundUsers.length == 0 ? ' Anyway' : ''}}</b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Today's Appointments">
            <div class="row mt-4">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">Select customer with today's appointment:</div>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <b-form-select
                      :options="clientsWithAppts"
                      id="clApptSMSPhone"
                      v-model="nsmsphone"
                      type="tel"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="row mt-4">
                  <!-- <div class="col-2"></div> -->
                  <div class="col-12">
                    <b-button
                      style="width: 100%"
                      variant="primary"
                      @click="CreateSMSRoom()"
                      :disabled="nsmsphone.length < 10 || nsmsphone == ''"
                    >{{valid(nsmsphone) ? 'Message Customer at ' + nsmsphone : 'Select Customer'}}</b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-modal>
    </b-row>
  </div>
</template>


<script>
import firebase from "firebase/app";
import "firebase/firestore";
import ChatList from "./ChatComponents/ChatList.vue";
import MainChatWindow from "./ChatComponents/MainChatWindow.vue";
import UserInfo from "./ChatComponents/UserInfo.vue";

export default {
  name: "Chat",
  components: {
    ChatList,
    MainChatWindow,
    UserInfo
  },

  props: {
    currAdmin: Object,
    rooms: Array,
    roomStats: Object,
    messages: Object,
    admins: Array
  },
  data() {
    return {
      allUsers: {},
      selectedRoomId: "",
      prevSelectedRoomId: "",
      chats: [],

      expiredRoom: {},

      newBotMessages: [],
      windowHeight: 500,
      windowWidth: 1440,
      userPhotoURL: "",
      currRoom: {},
      botRooms: [],
      roomStatus: {},
      botRoomLastCheck: {},

      nsmsphone: "",
      smsuserloading: false,
      foundUsers: [],
      searchInitiated: false,
      foundUserSelected: null,

      clientsWithAppts: []
    };
  },

  created() {
    window.addEventListener("resize", this.getWindowHeight);

    this.$nextTick(function() {
      this.getWindowHeight();
    });

    window.addEventListener("beforeunload", () => {
      if (this.valid(this.selectedRoomId)) {
        this.ChangeWatchingStatus(this.selectedRoomId, false);
      }
    });
  },

  mounted() {},
  computed: {
    roomExist: function() {
      return this.rooms.find(el => el.ssId == this.selectedRoomId) != undefined;
    },
    watchAdminsList: function() {
      let arr = [
        { value: "", text: "select representative" },
        { value: "bot", text: "chatbot" }
      ];

      return this.AdminsList(arr);
    }
  },
  watch: {
    nsmsphone: function(val) {
      if (val.length != 10) {
        this.searchInitiated = false;
        this.foundUsers = [];
        this.foundUserSelected = null;
      }
    },
    selectedRoomId: function(val) {
      this.$emit("selectedRoom", val);

      if (
        this.prevSelectedRoomId != "" &&
        this.rooms.find(el => el.ssId == this.prevSelectedRoomId)
      ) {
        this.ChangeWatchingStatus(this.prevSelectedRoomId, false);
      }

      if (this.valid(val)) {
        this.ChangeWatchingStatus(val, true);
      }
      this.prevSelectedRoomId = val;
    }
  },

  methods: {
    LoadTodaysAppointments() {
      if (this.clientsWithAppts.length == 0) {
        let todaysDate = new Date().toLocaleDateString("en-US", {
          timeZone: "America/Edmonton"
        });
        let that = this;
        this.smsuserloading = true;
        firebase
          .firestore()
          .collection(`events`)
          .where(`sch`, "==", `${this.currAdmin.location}/appointment`)
          .where("xdate", ">=", Date.parse(`${todaysDate} 12:00:02 AM MDT`))
          .where("xdate", "<=", Date.parse(`${todaysDate} 11:55:58 PM MDT`))
          .get()
          .then(clappts => {
            clappts.forEach(clapptData => {
              let clappt = clapptData.data();
              if (this.valid(clappt.userId) && this.valid(clappt.car)) {
                that.clientsWithAppts.push({
                  value: `${clappt.cell}`,
                  text: `${clappt.user_name} ${clappt.user_lastname} - ${
                    clappt.userId
                  } (${clappt.car.make || ""} ${clappt.car.model || ""} ${
                    clappt.car.year
                  })`
                });
              }
            });
            that.smsuserloading = false;
          });
      }
    },
    ExpiredRoomProcess: function(data) {
      this.expiredRoom = this.rooms.find(el => el.ssId == data.roomId);
      if (this.expiredRoom) {
        if (data.expired === false) {
          this.$bvModal.show("unfinishedChatModal");
        } else {
          if (this.selectedRoomId == this.expiredRoom.ssId) {
            this.$bvModal.hide("unfinishedChatModal");
          }
          this.SwitchRoomTo(
            data.roomId,
            this.expiredRoom.clientEndpoint == "sms" ? "smsNotFinished" : "bot"
          );
          this.expiredRoom = {};
        }
      }
    },

    ChangeWatchingStatus(roomId, status) {
      if (status) {
        let obj = new Object();
        obj[this.currAdmin.id] = true;
        firebase
          .database()
          .ref(`roomStatus/${roomId}/adminsWatching`)
          .update(obj);
      } else {
        firebase
          .database()
          .ref(`roomStatus/${roomId}/adminsWatching/${this.currAdmin.id}`)
          .remove();
      }
    },
    addToAllUsers: function(v) {
      if (this.valid(v.id)) {
        for (let key in v) {
          if (key != "id") {
            if (key == "user") {
              this.$set(this.allUsers, v.id, v.user);
            } else {
              this.$set(this.allUsers[v.id], key, v[key]);
            }
          }
        }
      }
    },
    AdminsList(arr) {
      for (let i in this.admins) {
        if (this.admins[i].adminRole > this.currAdmin.role) {
          arr.push({
            value: this.admins[i].adminId,
            text: `${this.admins[i].name} (${this.admins[i].adminEmail})`
          });
        }
      }
      return arr;
    },
    valid(vl) {
      return vl != undefined && vl != null && vl != "";
    },
    SwitchChatTo: function(val) {
      if (this.valid(val.ssId) && this.valid(val.adminId)) {
        this.SwitchRoomTo(val.ssId, val.adminId);
      }
    },

    SwitchRoomTo(ssId, adminId) {
      let obj = this.CheckSwitchingAdmin(ssId, adminId);
      obj = this.valid(obj.adminId)
        ? this.AddParticipants(ssId, adminId, obj)
        : obj;

      firebase
        .database()
        .ref(`chatrooms/${ssId}`)
        .update(obj);

      this.CheckAssignedTime(ssId, adminId);
    },

    AddParticipants(ssId, adminId, obj) {
      if (
        this.rooms.find(
          el => el.ssId == ssId && !el.adminParticipants.includes(adminId)
        )
      ) {
        obj["adminParticipants"] = this.rooms
          .find(el => el.ssId == ssId)
          .adminParticipants.concat([adminId]);
      }
      return obj;
    },

    CheckSwitchingAdmin(ssId, adminId) {
      let obj = { adminId: adminId };
      let room = this.rooms.find(el => el.ssId == ssId);

      if (this.valid(room) && room.clientEndpoint == "sms") {
        obj["isActive"] = adminId != "smsFinished" && adminId != "bot";
        obj.adminId =
          adminId == "smsFinished" ||
          adminId == "smsNotFinished" || //added this line; smsNotFinished => comes from expired rooom AUTOSwitching ONLY to keep the sms convo active
          adminId == "bot"
            ? ""
            : adminId;
      }
      return obj;
    },

    CheckAssignedTime(ssId, adminId) {
      //Check if room is being assigned to notHuman to reset exipiry
      if (
        !this.admins.find(el => el.adminId == adminId) &&
        adminId != this.currAdmin.id
      ) {
        firebase
          .database()
          .ref(`chatrooms/${ssId}/assign_expire`)
          .remove();
      }
    },

    ExtendExpireTime(ssId) {
      let that = this;
      firebase
        .database()
        .ref(`chatrooms/${ssId}`)
        .update({
          assign_expire: this.expiredRoom.assign_expire + 20 * 60 * 1000
        })
        .then(() => {
          that.expiredRoom = {};
        });
    },

    getWindowHeight() {
      this.windowHeight = document.documentElement.clientHeight;
      this.windowWidth = document.documentElement.clientWidth;
    },

    SendMessage: function(vl) {
      firebase
        .database()
        .ref("messages")
        .push()
        .set({
          type: "text",
          author: this.currAdmin.userOptionalName,
          data: { text: vl.msg },
          ssId: vl.room.ssId,
          route: {
            adminId: this.currAdmin.id,
            client: vl.room.clientEndpoint,
            from: "admin",
            division: `${this.currAdmin.division}`,
            wiId:
              vl.room.clientEndpoint === "widget" && this.valid(vl.room.wiId)
                ? vl.room.wiId
                : null,
            userId:
              vl.room.clientEndpoint === "widget" && this.valid(vl.room.userId)
                ? vl.room.userId
                : null,
            phone:
              vl.room.clientEndpoint === "sms" && this.valid(vl.room.userphone)
                ? vl.room.userphone
                : null,
            fbId:
              vl.room.clientEndpoint === "facebook" &&
              this.valid(vl.room.userfbId)
                ? vl.room.userfbId
                : null
          },
          sendDate: Date(),
          author_type: "manager",
          readMsg: false
        });
    },
    CreateSMSRoom() {
      let user =
        this.foundUsers.length > 0 && this.valid(this.foundUserSelected)
          ? this.foundUserSelected
          : new Object();
      let room = {
        adminId: this.currAdmin.id,
        adminName: "",
        adminParticipants: [this.currAdmin.id],
        clientEndpoint: "sms",
        department: "service",
        division: `${this.currAdmin.location}/service`,
        userphone: `+1${this.nsmsphone}`,
        s_location: this.currAdmin.location,
        s_location_name: "",
        ssId: `${this.uigen()}${this.uigen()}`,
        userId: user.id || "",
        user_firstName: user.firstName || "",
        user_lastName: user.lastName || "",
        userfbId: "",
        isActive: true,
        dateRoomCreate: Date.now(),
        wiId: `+1${this.nsmsphone}`
      };

      firebase
        .database()
        .ref(`chatrooms/${room.ssId}`)
        .set(room);

      let obj = new Object();
      obj[this.currAdmin.id] = true;
      firebase
        .database()
        .ref(`roomStatus/${room.ssId}`)
        .set({
          client_page: "sms",
          adminsWatching: obj
        });

      this.$refs["newSMSRoom"].hide();
      // this.$bvModal.newSMSRoom.hide();
    },

    searchSMSUser() {
      this.smsuserloading = true;
      this.searchInitiated = true;
      let that = this;
      firebase
        .firestore()
        .collection(`users`)
        .where("phones_on_file", "array-contains", this.nsmsphone)
        .get()
        .then(rss => {
          rss.forEach(rs => {
            let temp = rs.data();
            temp.homelocation =
              temp.homelocation == "" ? "londonderrydodge" : temp.homelocation;
            if (rs.data().homelocation == this.currAdmin.location) {
              that.foundUsers.push(temp);
            }
          });
          that.smsuserloading = false;
        });
    },
    uigen() {
      return (
        "sm" +
        Math.random()
          .toString(36)
          .substr(2, 9)
      );
    }

    // beforeDestroy() {
    //   if (this.valid(this.selectedRoomId)) {
    //     this.ChangeWatchingStatus(this.selectedRoomId, false);
    //   }
    //   window.removeEventListener("resize", this.getWindowHeight);
    // }
  }
};
</script>



<style scoped>
.usersInfo {
  /* position: fixed; */
  overflow-x: hidden;
  overflow-y: scroll;
}

.headerChatList {
  /* height: 70px; */
  color: #f5f5f5;
  background-color: rgb(49, 57, 76);
  padding: 15px 0px;
}

.membersList {
  padding: 0px;
}
.displayChatName {
  /* display: inline; */
  text-align: left;
  padding-left: 0px;
}

hr.style-two {
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.445),
    rgba(0, 0, 0, 0)
  );
  margin-top: 0px;
  margin-bottom: 0px;
}

.hrBackColor {
  background-color: rgb(49, 57, 76);
}

.noPaddingsLR {
  padding-left: 0px;
  padding-right: 0px;
  text-align: left;
  display: inline;
}

.btn-outline-primary {
  color: #266db3;
  border-color: #266db3;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #266db3;
  border-color: #266db3;
}

a:hover {
  background-color: rgba(255, 255, 255, 0);
}

/* .headerChatList .rounded-circle {
  width: 43px !important;
} */

.notActiveChat {
  background-image: url(https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/roomadmin_pictures%2Fbackground_blur.jpg?alt=media&token=a9438a9a-6368-48bf-9aa5-0f600aabb0eb);
}
.positionMiddle {
  top: 50%;
  position: absolute;
  right: 35%;
  background-color: #0000006b;
  border-radius: 50px;
  color: #f3f3f3;
  padding: 15px 25px 10px 25px;
}

#chatLists .row {
  margin-left: 0;
  margin-right: 0;
}
</style>



